<template>
    <div class="basic-setting-content pl16 pr16">
        <!--基本信息-->
        <div class="common-form">法人信息</div>

        <el-form-item label="账户类型" :rules="[{required: true,message: '请选择账户类型'}]">
            <el-radio-group v-model="formData.acctAttr">
                <el-radio :label="0">对私</el-radio>
                <el-radio :label="1">对公</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="账号" :rules="[{required: true,message: '请输入账号'}]">
            <el-input v-model="formData.acctNum" placeholder="请输入账号" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="银行预留手机" :rules="[{required: true,message: '请输入银行预留手机'}]">
            <el-input v-model="formData.bankReservePhone" placeholder="请输入银行预留手机" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="银行代码" :rules="[{required: true,message: '请输入开户行支行名称'}]">
            <el-input v-model="formData.openBankNo" placeholder="请输入开户行支行名称" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="开户行支行名称" :rules="[{required: true,message: '请输入证件有效开始日期'}]">
            <el-input v-model="formData.openBankBranchName" placeholder="请输入证件有效开始日期" class="max-w460" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="支付行号" :rules="[{required: true,message: '请输入支付行号'}]">
            <el-input v-model="formData.payBankNumber" placeholder="请输入支付行号" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="开户行所在" :rules="[{required: true,message: '请输入开户行所在'}]">
            <el-input v-model="formData.openBankProvince" placeholder="请输入开户行所在" class="max-w460" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="开户行所在市" :rules="[{required: true,message: '请输入开户行所在市'}]">
            <el-input v-model="formData.openBankCity" placeholder="请输入开户行所在市" class="max-w460" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="">
            <!--<el-button @click="chooseImg('business')">选择营业执照</el-button>-->
            <div v-if="formData.business_id!=''" class="img">
                <img :src="formData.legpCerBackFileId" width="100" height="100"/>
            </div>
        </el-form-item>

    </div>
</template>

<script>
    export default {
        components: {

        },
        data() {
            return {

            }
        },
        inject: ['formData'],
        watch: {

        },
        created() {

        },
        methods: {

        }
    }
</script>




// WEBPACK FOOTER //
// src/views/setting/supplier/part/Bank.vue